import { InjectionToken } from '@angular/core';

/**
 * Mutable per-request holder the render writes its intended HTTP status into.
 *
 * CommonEngine renders to a string and gives the Express layer no way to signal
 * "this URL does not exist", so every unknown booking slug used to be answered
 * with 200 + the generic app shell. Search engines read that as thousands of
 * near-identical indexable pages sharing one boilerplate <title>, which is what
 * lets Google discard our titles and substitute another partner's name.
 *
 * The resolver sets `status` only for a definitive "no such partner" answer from
 * the API; transient failures deliberately leave it at 200 so a blip can never
 * deindex a live booking page.
 */
export interface SsrResponseContext {
  status: number;
  /**
   * Set when the partner has opted their booking page out of search results, so the server can
   * say so in the response headers as well as the markup. The meta tag alone is the covering
   * signal for a client-side route change, which carries no headers — the two are complementary,
   * and neither is sufficient on its own.
   */
  noIndex?: boolean;
}

export const SSR_RESPONSE_CONTEXT = new InjectionToken<SsrResponseContext>('SSR_RESPONSE_CONTEXT');
